import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import FormHelper from 'helpers/FormHelper';
import FileList from '../../../../../../../components/fileList/index.';
import { Descriptions } from 'antd';

const ImagesSection = ({
  singleItem,
  updateInProcess,
  handleDeleteFile,
  isView,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <Row gutter={24}>
        <Col span={6}>
          <Typography.Title level={3}>
            {t('Files')}
          </Typography.Title>
        </Col>
        <Col span={9}>
        <Form.Item label={t('Immagine miniatura (jpg, png, gif)')}>
          <Form.Item
            name='image_mini'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
            // rules={rules}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.image_mini
                  ? [
                      {
                        file: {
                          url: singleItem?.allData?.image_mini,
                          file_name: singleItem?.allData?.image_mini_name || 'name',
                          id: singleItem?.allData?.image_mini_id || 'id',
                        },
                        image_id: singleItem?.allData?.image_mini_id,
                        param: 'image_mini',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Immagine hero (jpg, png, gif)')}>
          <Form.Item
            name='image'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
            // rules={rules}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  {/* <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  JPG PNG SVG
                  </Descriptions.Item> */}
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.image
                  ? [
                      {
                        file: {
                          url: singleItem?.allData?.image,
                          file_name: singleItem?.allData?.image_name || 'name',
                          id: singleItem?.allData?.image_id || 'id',
                        },
                        image_id: singleItem?.allData?.image_id,
                        param: 'image',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={6}></Col>
      <Col span={9}>
        <Form.Item label={t('Logo(jpg, png, gif)')}>
          <Form.Item
            name='logo'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  {/* <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  JPG PNG SVG
                  </Descriptions.Item> */}
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={isView}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.logo
                  ? [
                      {
                        file: {
                          url: singleItem?.allData?.logo,
                          file_name: singleItem?.allData?.logo_name || 'name',
                          id: singleItem?.allData?.image_id || 'id',
                        },
                        image_id: singleItem?.allData?.logo_id,
                        param: 'logo',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Video clip(avi, flv, 3gp, wmv, mpeg, mp4, mov)')}>
          <Form.Item
            name='video_clip'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              disabled={isView}
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  {/* <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  AVI FLV 3GP WMV MPEG MP4 MOV
                  </Descriptions.Item> */}
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
        <Row>
          <Col span={24}>
            <FileList
              hideDeleteBtn={true}
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.allData?.video_clip
                  ? [
                      {
                        file: {
                          url: singleItem?.allData?.video_clip,
                          file_name:
                            singleItem?.allData?.video_clip_name || 'name',
                          id: singleItem?.allData?.image_id || 'id',
                        },
                        image_id: singleItem?.allData?.video_clip_id,
                        param: 'video',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
    </div>
  );
};

export default React.memo(ImagesSection);